// client/src/App.js
import React, { useState } from 'react';
import Home from './components/Home';
import Room from './components/Room';
import './styles/App.css';

function App() {
  const params = new URLSearchParams(window.location.search);

  const [roomId, setRoomId] = useState(() =>
    (params.get('room') || params.get('roomid')|| params.get('roomId') || '')
  );
  const [nickname, setNickname] = useState(() =>
    (params.get('name') || params.get('nickname') || params.get('userId') || '')
  );

  const [joined, setJoined] = useState(false);
  const [localStream, setLocalStream] = useState(null);
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [videoEnabled, setVideoEnabled] = useState(true);

  return (
    <div className="app">
      {!joined ? (
        <Home
          roomId={roomId}
          setRoomId={setRoomId}
          nickname={nickname}
          setNickname={setNickname}
          setJoined={setJoined}
          localStream={localStream}
          setLocalStream={setLocalStream}
          audioEnabled={audioEnabled}
          setAudioEnabled={setAudioEnabled}
          videoEnabled={videoEnabled}
          setVideoEnabled={setVideoEnabled}
        />
      ) : (
        <Room
          roomId={roomId}
          nickname={nickname}
          setJoined={setJoined}
          localStream={localStream}
          setLocalStream={setLocalStream}
          audioEnabled={audioEnabled}
          setAudioEnabled={setAudioEnabled}
          videoEnabled={videoEnabled}
          setVideoEnabled={setVideoEnabled}
        />
      )}
    </div>
  );
}

export default App;